module.exports = __webpack_public_path__ + "img/image 11.9397f6b0.png";